<template>
    <div class="_td-table-opt">
        <table class="_td-table-opt-table">
            <thead>
                <tr>
                    <th v-for="(col, idx) in column" :key="col.label + idx">{{ col.label }}</th>
                    <th v-if="!disabled" class="_td-table-opt-handle-col"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, ridx) in value" :key="ridx">
                    <td v-for="(col, idx) in column" :key="col.label + idx">
                        <ValueInput v-if="col.value" :size="size || 'small'" :modelValue="row[col.key]"
                                    :disabled="disabled"
                                    @update:modelValue="(n)=>(row[col.key] = n)"
                                    @blur="onInput(row)" @change-type="onInput(row)"></ValueInput>
                        <z-input v-else :size="size || 'small'" :disabled="disabled" :modelValue="row[col.key] || ''"
                                 @Update:modelValue="(n)=>(row[col.key] = n)"
                                 @blur="onInput(row)"
                                 @keydown.enter="onInput(row)"></z-input>
                    </td>
                    <td v-if="!disabled" class="_td-table-opt-handle-col">
                        <i class="fc-icon icon-delete" @click="del(ridx)"></i>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="_td-table-opt-handle">
            <z-button link type="primary" @click="add" v-if="!max || max > value.length">
                <i class="fc-icon icon-add"></i> {{ t('tableOptions.add') }}
            </z-button>
        </div>

    </div>
</template>

<script>
import {defineComponent} from 'vue';
import {copy} from '@form-create/utils/lib/extend';
import ValueInput from './ValueInput.vue';

export default defineComponent({
    name: 'TableOptions',
    emits: ['update:modelValue', 'change'],
    components: {
        ValueInput
    },
    props: {
        modelValue: [Array, Object],
        column: {
            type: Array,
            default: () => [{label: 'label', key: 'label'}, {label: 'value', key: 'value'}]
        },
        valueType: String,
        max: Number,
        size: String,
        disabled: Boolean,
    },
    inject: ['designer'],
    watch: {
        modelValue() {
            this.value = this.tidyModelValue();
        }
    },
    computed: {
        t() {
            return this.designer.setupState.t;
        },
    },
    data() {
        return {
            value: this.tidyModelValue(),
        };
    },
    methods: {
        tidyModelValue() {
            const modelValue = this.modelValue;
            if (this.valueType === 'string') {
                return (modelValue || []).map(value => {
                    return {value: '' + value}
                })
            } else if (this.valueType === 'object') {
                return Object.keys((modelValue || {})).map(label => {
                    return {label, value: modelValue[label]}
                })
            } else {
                return [...modelValue || []].map(v => {
                    return copy(v);
                });
            }
        },
        tidyValue() {
            if (this.valueType === 'object') {
                const obj = {};
                this.value.forEach(v => {
                    if (v.label && v.value) {
                        obj[v.label] = v.value;
                    }
                })
                return obj;
            } else {
                return this.value.map(v => {
                    if (this.valueType === 'string') {
                        return v.value;
                    }
                    return {...v}
                });
            }
        },
        onInput(item) {
            if (this.column.length === 1 && '' === item[this.column[0].key]) {
                return;
            }
            const flag = this.column.every(v => {
                if (v.required === false) {
                    return true;
                }
                if (['object', 'string'].indexOf(this.valueType) > -1) {
                    return item[v.key] !== undefined && item[v.key] !== '' && item[v.key] !== null;
                }
                return item[v.key] !== undefined;
            })
            if (flag) {
                this.input();
            }
        },
        input() {
            const value = this.tidyValue();
            this.$emit('update:modelValue', value);
            this.$emit('change', value);
        },
        add() {
            this.value.push(this.column.reduce((initial, v) => {
                initial[v.key] = '';
                return initial;
            }, {}));
        },
        del(idx) {
            this.value.splice(idx, 1);
            this.input();
        }
    }
});
</script>

<style scoped>
._td-table-opt {
    width: 100%;
}

._td-table-opt-table {
    z-index: 1;
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
}

._td-table-opt-table th,
._td-table-opt-table td {
    border: 1px solid var(--z-border-color-lighter, #ebeef5);
    padding: 6px 8px;
    font-size: 12px;
    font-weight: 400;
    text-align: left;
}

._td-table-opt-table th {
    background: var(--z-fill-color-light, #f5f7fa);
    color: var(--z-text-color-regular, #606266);
}

._td-table-opt-handle-col {
    width: 45px;
    text-align: center;
    cursor: pointer;
}

._td-table-opt-handle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 5px;
}
</style>
